import type { IMenuItemProps } from '../../Menu.types';

type Item = IMenuItemProps['item'];
type ForceOpenIfNeededProps = {
  items: Array<Item>;
  editSlotId?: string;
  itemId?: string;
};

export const forceOpenIfNeeded = ({
  items,
  editSlotId,
  itemId,
}: ForceOpenIfNeededProps): Array<Item> => {
  if (editSlotId || itemId) {
    return items.map(item =>
      item.slot === editSlotId || item.id === itemId
        ? { ...item, forceHovered: true }
        : item,
    );
  }

  return items;
};
